// src/config.js
// ─────────────────────────────────────────────────────────────────────────────
// Single source of truth for the backend API base URL.
// To point the app at a different backend, change ONLY the line below.
// ─────────────────────────────────────────────────────────────────────────────
export const API_BASE_URL = 'https://nua7tm3quj.execute-api.ap-south-1.amazonaws.com';
// export const API_BASE_URL = 'https://nua7tm3quj.execute-api.ap-south-1.amazonaws.com';

export const PEXELS_API_KEY = process.env.REACT_APP_PEXELS_API_KEY || '';
